import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Home/Home';
import ProductList from '../ProductList/ProductList';
import ProductDetails from '../ProductDetails/ProductDetails';
import AddToCart from '../AddToCart/AddToCart';
import Checkout from '../Checkout/Checkout';
import Signup from '../Register/Signup';
import Signin from '../Register/Signin';
import Profile from '../Profile/Profile';
import WishList from '../WishList/WishList';
import Orders from '../Orders/Orders';
import OrderDetails from '../Orders/OrderDetails';
import Policies from '../Policies/Policies';
import FAQs from '../FAQs/FAQs';
import Subcategory from '../Subcategory/Subcategory';
import Rewards from '../Rewards/Rewards';
import Notification from '../Notification/Notification';

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Dynamic route for category product list pages, e.g. /hair-care/Shampoo */}
      <Route path="/:category/:subcategory" element={<ProductList />} />
      <Route path="/search" element={<ProductList />} />
      {/* Product details route */}
      <Route path="/product/:id" element={<ProductDetails />} />
      {/* Add to cart route */}
      <Route path="/addtocart" element={<AddToCart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signin" element={<Signin />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/wishlist' element={<WishList />} />
      <Route path='/orders' element={<Orders />} />
      <Route path='/orderdetails/:id' element={<OrderDetails />} />
      <Route path='/policies' element={<Policies />} />
      <Route path='/faqs' element={<FAQs />} />
      <Route path='/:category' element={<Subcategory />} />
      <Route path='/rewards' element={<Rewards />} />
      <Route path='/notification' element={<Notification />} />
    </Routes>
  );
};


export default MainRoutes;
